import React from "react";

const VectorUmbrella = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="200"
            height="180"
            viewBox="0 0 200 180"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            {/* Shadow on Sand for all items */}
            <ellipse cx="100" cy="165" rx="70" ry="10" fill="#3D2B1F" opacity="0.1" />

            {/* Umbrella - Grouped for synchronized tilt */}
            <g transform="translate(100, 160) rotate(-12)">
                {/* Pole - Shortened by 20% (from 120 to 96) */}
                <path d="M0 0 L0 -96" stroke="#E0E0E0" strokeWidth="4" strokeLinecap="round" />

                {/* Canopy - Lowered (from -115 to -92) */}
                <g transform="translate(0, -92)">
                    {/* Underside / Shadow - Wider span */}
                    <path d="M-55 15 Q0 0 55 15 Q0 30 -55 15 Z" fill="#333" opacity="0.1" />

                    {/* Main Dome - Broad Arc */}
                    <path d="M0 -35 C-35 -35 -55 -10 -55 15 Q0 0 55 15 C55 -10 35 -35 0 -35 Z" fill="#EF5350" />

                    {/* White Segment (Front Center) - Broader */}
                    <path d="M0 -35 Q-15 -10 -20 18 Q0 15 20 18 Q15 -10 0 -35 Z" fill="#FFFFFF" />

                    {/* Red Segments (Left and Right) - Broader span */}
                    <path d="M0 -35 Q-30 -25 -55 15 Q-40 10 -20 18 Q-15 -10 0 -35 Z" fill="#EF5350" />
                    <path d="M0 -35 Q30 -25 55 15 Q40 10 20 18 Q15 -10 0 -35 Z" fill="#EF5350" />

                    {/* Top Center Detail */}
                    <path d="M-6 -35 Q0 -42 6 -35 Z" fill="#FFFFFF" />

                    {/* Bottom Trim / Rib edges - Wider span */}
                    <path d="M-55 15 Q-40 10 -20 18 Q0 15 20 18 Q40 10 55 15" stroke="#FFFFFF" strokeWidth="1.8" fill="none" />
                </g>
            </g>

            {/* Suitcase (Vali) at the base */}
            <g transform="translate(55, 125)">
                <rect x="0" y="0" width="70" height="40" rx="3" fill="#A1887F" stroke="#5D4037" strokeWidth="1" />
                <rect x="15" y="0" width="6" height="40" fill="#5D4037" />
                <rect x="49" y="0" width="6" height="40" fill="#5D4037" />
                <path d="M25 0 Q35 -15 45 0" stroke="#3E2723" strokeWidth="3" strokeLinecap="round" fill="none" />
                <rect x="15" y="15" width="6" height="5" rx="1" fill="#FFD54F" />
                <rect x="49" y="15" width="6" height="5" rx="1" fill="#FFD54F" />
            </g>

            {/* Pith Helmet (Nón Cối) on suitcase */}
            <g transform="translate(95, 110) rotate(5)">
                {/* Brim */}
                <ellipse cx="20" cy="18" rx="22" ry="7" fill="#ecf388ff" stroke="#71961bff" strokeWidth="0.5" />
                {/* Crown - Dome shaped pith helmet */}
                <path d="M5 18 Q5 2 20 2 Q35 2 35 18" fill="#ecf388ff" stroke="#71961bff" strokeWidth="0.5" />
                {/* Brown Band */}
                <path d="M5 13 Q20 12 35 13 V15 Q20 14 5 15 Z" fill="#5e3323ff" />
            </g>

            {/* Flip-flops (Dép kẹp) */}
            <g transform="translate(35, 150)">
                {/* Left Flip-flop */}
                <g transform="rotate(-10)">
                    <rect x="0" y="0" width="12" height="22" rx="6" fill="#df2f69ff" />
                    <path d="M6 4 L1 12 M6 4 L11 12" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" />
                </g>
                {/* Right Flip-flop */}
                <g transform="translate(20, -5) rotate(15)">
                    <rect x="0" y="0" width="12" height="22" rx="6" fill="#df2f69ff" />
                    <path d="M6 4 L1 12 M6 4 L11 12" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" />
                </g>
            </g>
        </svg>
    );
};

export default VectorUmbrella;
